/**
 * Mappa provincia (sigla NTS, es. "MI", "NA") → regione italiana.
 *
 * Il gestionale NTS non espone un campo "regione" diretto per il cliente:
 * viene derivata qui dalla provincia per la colonna "Regione" in
 * `AdminClientsPage.tsx` (richiesta utente 23/02/2026).
 */
const PROVINCIA_TO_REGIONE: Record<string, string> = {
  TO: 'Piemonte', VC: 'Piemonte', NO: 'Piemonte', CN: 'Piemonte', AT: 'Piemonte',
  AL: 'Piemonte', BI: 'Piemonte', VB: 'Piemonte',
  AO: "Valle d'Aosta",
  IM: 'Liguria', SV: 'Liguria', GE: 'Liguria', SP: 'Liguria',
  VA: 'Lombardia', CO: 'Lombardia', SO: 'Lombardia', MI: 'Lombardia', BG: 'Lombardia',
  BS: 'Lombardia', PV: 'Lombardia', CR: 'Lombardia', MN: 'Lombardia', LC: 'Lombardia',
  LO: 'Lombardia', MB: 'Lombardia',
  BZ: 'Trentino-Alto Adige', TN: 'Trentino-Alto Adige',
  VR: 'Veneto', VI: 'Veneto', BL: 'Veneto', TV: 'Veneto', VE: 'Veneto', PD: 'Veneto', RO: 'Veneto',
  UD: 'Friuli-Venezia Giulia', GO: 'Friuli-Venezia Giulia', TS: 'Friuli-Venezia Giulia', PN: 'Friuli-Venezia Giulia',
  PC: 'Emilia-Romagna', PR: 'Emilia-Romagna', RE: 'Emilia-Romagna', MO: 'Emilia-Romagna',
  BO: 'Emilia-Romagna', FE: 'Emilia-Romagna', RA: 'Emilia-Romagna', FC: 'Emilia-Romagna', RN: 'Emilia-Romagna',
  MS: 'Toscana', LU: 'Toscana', PT: 'Toscana', FI: 'Toscana', LI: 'Toscana', PI: 'Toscana',
  AR: 'Toscana', SI: 'Toscana', GR: 'Toscana', PO: 'Toscana',
  PG: 'Umbria', TR: 'Umbria',
  PS: 'Marche', PU: 'Marche', AN: 'Marche', MC: 'Marche', AP: 'Marche', FM: 'Marche',
  VT: 'Lazio', RI: 'Lazio', RM: 'Lazio', LT: 'Lazio', FR: 'Lazio',
  AQ: 'Abruzzo', TE: 'Abruzzo', PE: 'Abruzzo', CH: 'Abruzzo',
  CB: 'Molise', IS: 'Molise',
  CE: 'Campania', BN: 'Campania', NA: 'Campania', AV: 'Campania', SA: 'Campania',
  FG: 'Puglia', BA: 'Puglia', TA: 'Puglia', BR: 'Puglia', LE: 'Puglia', BT: 'Puglia',
  PZ: 'Basilicata', MT: 'Basilicata',
  CS: 'Calabria', CZ: 'Calabria', RC: 'Calabria', KR: 'Calabria', VV: 'Calabria',
  TP: 'Sicilia', PA: 'Sicilia', ME: 'Sicilia', AG: 'Sicilia', CL: 'Sicilia',
  EN: 'Sicilia', CT: 'Sicilia', RG: 'Sicilia', SR: 'Sicilia',
  SS: 'Sardegna', NU: 'Sardegna', CA: 'Sardegna', OR: 'Sardegna', SU: 'Sardegna',
};

export function provinciaToRegione(provincia?: string | null): string {
  if (!provincia) return '—';
  return PROVINCIA_TO_REGIONE[provincia.trim().toUpperCase()] || '—';
}
